import React, { useState } from 'react';
import { Collapse, IconButton, TableCell, TableRow, Table, TableBody } from '@material-ui/core';
import { AddBoxOutlined, IndeterminateCheckBoxOutlined } from '@material-ui/icons';
import { calculateSums } from 'pages/analytics/utils/sales';
import TotalsTableCells from './TotalsTableCells';


interface CollapsibleTableRowProps {
  title: string;
  children: React.ReactNode;
  data: Record<string, unknown>; // TODO: Replace 'unknown' to a more specific type as inheritance of objects is unknown
  leftGap: number;
}

const CollapsibleTableRow: React.FC<CollapsibleTableRowProps> = ({ title, children, data, leftGap }) => {
  const [isOpen, setIsOpen] = useState(false);
  const totals = calculateSums(data);

  return (
    <>
      <TableRow style={{ borderBottom: '1px solid #d9d9d9' }}>
        <TableCell className={`border-none p-0 pl-${leftGap}`} width="150px">
          <IconButton aria-label="expand row" size="small" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <IndeterminateCheckBoxOutlined fontSize="small" /> : <AddBoxOutlined fontSize="small" />}
          </IconButton>
          {title}
        </TableCell>
        <TotalsTableCells totals={totals} />
      </TableRow>
      <TableRow style={{ borderBottom: '1px solid #d9d9d9' }}>
        <TableCell colSpan={6} className="border-none p-0">
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Table>
              <TableBody>{children}</TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CollapsibleTableRow;
